import { render, staticRenderFns } from "./AccountConnections.vue?vue&type=template&id=526112ca&"
import script from "./AccountConnections.vue?vue&type=script&lang=js&"
export * from "./AccountConnections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports